import { GalleryService } from "features/gallery/service/gallery.service"
import { computed, ref } from "vue"
import { Highlight } from "suus-api"
import { useFetchPreviewHighlights } from "features/events/highlights/concerns/use-fetch-preview-highlights"

export const useHighlightsWithOptimism = (
  eventId: number,
  galleryService: GalleryService
) => {
  const { isLoading, error, highlights, loadHighlights } =
    useFetchPreviewHighlights(eventId)

  const optimisticHighlights = ref<Highlight[]>([])
  const _highlights = computed(() => {
    return [...highlights.value, ...optimisticHighlights.value]
  })

  const _loadHighlights = async () => {
    optimisticHighlights.value = []
    await loadHighlights()
  }

  galleryService.registerAddListener((highlight) => {
    optimisticHighlights.value.push(highlight)
  })

  galleryService.registerRemoveListener(() => {
    _loadHighlights()
  })

  galleryService.registerReorderListener(() => {
    _loadHighlights()
  })

  const featuredImage = computed(() => _highlights.value[0])
  const gridHighlights = computed(() => _highlights.value.slice(1, 10))

  return {
    highlights: gridHighlights,
    isLoading,
    error,
    loadHighlights: _loadHighlights,
    featuredImage,
  }
}
